import { selectActivePrompt } from '../../../../store/selectors/pageSelectors';
import { useSelector } from 'react-redux';
import { ReactElement, useState, useEffect, useRef } from 'react';

import { commitHistory, updateSelectedImageSetting } from '../../../../store/slices/imageSlice';
import { EffectDef } from '../../../image-editor-page/widgets/prompt-blocks/EffectsBlock';
import { useAppDispatch } from '../../../../store/store';
import s from './EffectsAdjust.module.css';
import ImageFilter from 'react-image-filters-tool';
import {
    selectImageProject,
    selectSelectedImage,
} from '../../../../store/selectors/imageSelectors';
import Slider from '../../../../shared/ui/slider/Slider';

const EFFECTS: Array<{
    name: string;
    key: string;
    color: string;
}> = [
    { name: 'Tokyo', key: 'tokyo', color: '#FF0505' },
    { name: 'Malibu', key: 'malibu', color: '#FF2323' },
    { name: 'Miami', key: 'miami', color: '#FC4343' },
    { name: 'Sahara', key: 'sahara', color: '#FF8C8C' },
    { name: 'Rio', key: 'rio', color: '#FF6200' },
    { name: 'Phoenix', key: 'phoenix', color: '#FF914D' },
    { name: 'Jerusalem', key: 'jerusalem', color: '#FFCD68' },
    { name: 'Havana', key: 'havana', color: '#FFEB68' },
    { name: 'Arctic', key: 'arctic', color: '#053BFF' },
    { name: 'Silberian', key: 'silberian', color: '#2348FF' },
    { name: 'Oslo', key: 'oslo', color: '#4378FC' },
    { name: 'Icelandic', key: 'icelandic', color: '#8CABFF' },
];
const EffectsAdjust = () => {
    const activePrompt = useSelector(selectActivePrompt);
    const selectedImage = useSelector(selectSelectedImage);

    const [activeEffect, setActiveEffect] = useState<string>(
        selectedImage?.image?.visual_effects?.name || 'none',
    );
    const [intensity, setIntensity] = useState(
        selectedImage?.image?.visual_effects?.intensity || 100,
    );

    useEffect(() => {
        if (selectedImage?.image?.visual_effects?.name) {
            setActiveEffect(selectedImage.image.visual_effects.name);
            setIntensity(selectedImage.image.visual_effects.intensity || 100);
        }
    }, [selectedImage?.image?.visual_effects]);
    const dispatch = useAppDispatch();

    const handleEffectClick = (eff: EffectDef, isNoIntensity: boolean) => {
        if (activeEffect === eff.name) {
            setActiveEffect('none');
            setIntensity(100);
            dispatch(
                updateSelectedImageSetting({
                    key: 'visual_effects',
                    value: {
                        name: 'none',
                        intensity: 100,
                    },
                }),
            );
            return;
        }

        setActiveEffect(eff.name);
        setIntensity(eff.gradient ? 100 : intensity);

        dispatch(
            updateSelectedImageSetting({
                key: 'visual_effects',
                value: {
                    name: eff.name.toLowerCase(),
                    intensity: eff.gradient ? 100 : intensity,
                },
            }),
        );

        dispatch(commitHistory({ label: 'effect:set' }));
    };

    const handleIntensityChange = (value: number) => {
        setIntensity(value);
        dispatch(
            updateSelectedImageSetting({
                key: 'visual_effects',
                value: {
                    name: activeEffect === 'none' ? 'none' : activeEffect?.toLowerCase(),
                    intensity: value,
                },
            }),
        );

        dispatch(
            commitHistory({
                label: 'effect:intensity',
                opts: { groupId: 'effect:intensity', replace: true },
            }),
        );
    };

    if (activePrompt != 'effects') return null;

    return (
        <div className={s.container}>
            <h3 className={s.title}>Effects</h3>
            <p className={s.subtitle}>Choose the effect you want to apply to your image.</p>

            <div className={s.effects_container}>
                {EFFECTS.map((eff) => (
                    <div
                        key={eff.name}
                        className={s.effect_item}
                        onClick={() => handleEffectClick(eff, false)}
                    >
                        <div
                            className={s.effect_item_container}
                            style={{
                                border: activeEffect === eff.key ? '2px solid #FFDD35' : 'none',
                            }}
                        >
                            <ImageFilter
                                imageUrl={selectedImage?.image?.original_url || ''}
                                filter={eff.key}
                                preview={true}
                                styles={{
                                    height: '100%',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    objectFit: 'cover',
                                }}
                            />
                        </div>

                        <p className={s.effect_name}>{eff.name}</p>
                    </div>
                ))}
            </div>
            {activeEffect !== 'none' && activeEffect !== '' && (
                <div className={s.slider_container}>
                    <p className={s.slider_title}>Effect intensity</p>
                    <Slider
                        min={0}
                        max={100}
                        value={intensity}
                        onChange={handleIntensityChange}
                        label="number"
                    />
                </div>
            )}
        </div>
    );
};

export default EffectsAdjust;
